<template>
  <div
    class="message-carousel-section"
    v-if="messages.length">
    <div class="carousel-inner">
      <div class="title font-bold">
        {{ title }}
      </div>
      <div class="message-container container-fluid">
          <div
            class="col-4 nav-left"
            @click="previous">
            <i class="direction-icons material-icons">keyboard_arrow_left</i>
          </div>
          <div
            class="col-4 message">
            <transition
              name="fade"
              mode="out-in">
              <p :key="currentMsgId">
                {{ messages[currentMsgId].message }}
              </p>
            </transition>
          </div>
          <div
            class="col-4 nav-right"
            @click="next">
            <i class="material-icons">keyboard_arrow_right</i>
          </div>
      </div>
      <div class="dots">
        <ul class="plain-list">
          <li
            v-for="(message, i) of messages"
            :key="message.id"
            @click="currentMsgId = i"
            :class="{ 'active': i === currentMsgId }">
            <i
              class="material-icons">
              lens
            </i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageCarouselSection',
  props: {
    title: String,
    messages: { type: Array, default: function(){return []} },
  },
  data() {
    return {
      currentMessage: 0,
      currentMsgId: 0,
    };
  },
  methods: {
    next() {
      this.currentMsgId = this.currentMsgId === this.messages.length - 1
        ? 0
        : this.currentMsgId += 1;
    },
    previous() {
      this.currentMsgId = this.currentMsgId === 0
        ? this.messages.length - 1
        : this.currentMsgId -= 1;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.fade-enter-active, .fade-leave-active {
  transition: all .4s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.message-carousel-section  {
  background-color: $primary-color;
  color:$font-white;
  padding:2rem;

  .title {
    text-align: center;
    font-size: 1.5rem;
    padding:1.8rem;
  }

  .nav-right, .nav-left {
    cursor: pointer;
    padding:0;
    i {
      font-size: 3rem;
    }
  }
  .nav-right {
    text-align: right;
  }

  .nav-left {
    text-align: left;
  }

  .dots {
    text-align: center;
    ul>li {
      display: inline-block;
      margin: 0 0.7rem;
      cursor: pointer;
      &:hover, &.active {
        color:$orange-color;
      }
    }
  }

  .carousel {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .message-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &>div {
      text-align: center;
      padding-left:0!important;
      padding-right:0;
    }

    .message {
      flex: 0 1 20em;
      font-size: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 0.5s ease-in-out;
    }
  }

}

@media screen and (min-width: $break-sm) {
  .message-carousel-section  {
    padding:3rem;

    .nav-right, .nav-left {
      i {
        font-size: 7rem;
      }
    }
  }
}

</style>
